// extracted by mini-css-extract-plugin
module.exports = {"progressbar":"quizprogressbar_progressbar__1fiay"};